// extracted by mini-css-extract-plugin
module.exports = {"redeemAndPromoLink":"_1NuZzG"};